export default "__VITE_ASSET__0OJ15pFp__"